import { render, staticRenderFns } from "./SubKeysTable.vue?vue&type=template&id=5a2058e2&"
import script from "./SubKeysTable.vue?vue&type=script&lang=ts&"
export * from "./SubKeysTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports